import {computed, action, extendObservable} from "mobx";
import axios from "../../../libs/axios_csrf";
import {camelCase, snakeCase} from "@ridi/object-case-converter/dist/index";
import FeedbackChain from "../models/FeedbackChain";


export default class ValuePropositionsStore {

    constructor(rootStore) {
        this.rootStore = rootStore;
        extendObservable(this, {
            valuePropositions: [],
        });
    }


    @computed get valuePropositionsSelectOptions(){
        const vps = this.valuePropositions.map((vp) => ({
            label: vp.name,
            value: vp
        }));
        return vps;
    }

    getById(id){
        return this.valuePropositions.find( (vp) => vp.id == id );
    }

    selectableMvpsBoards(valuePropositionId){
        const valueProposition = this.getById(valuePropositionId);
        if( !valueProposition ){
            return [];
        } 
        const mvpsOptions = valueProposition.mvps.map(mvp =>
            ({
                label: mvp.name,
                options:
                    [
                        this._generateSelectableVpElement(mvp),
                        this._generateSelectableMvpFeatureElements(mvp.mvpFeatures, 'features'),
                        this._generateSelectableVpElement(mvp.infrSection),
                        this._generateSelectableMvpFeatureElements(mvp.infrSection.sectionFeatures, 'infrastructure_features'),
                        this._generateSelectableVpElement(mvp.crSection),
                        this._generateSelectableMvpFeatureElements(mvp.crSection.sectionFeatures, 'customer_relation_features'),
                        this._generateSelectableVpElement(mvp.monSection),
                        this._generateSelectableMvpFeatureElements(mvp.monSection.sectionFeatures, 'monetization_features')
                    ]
            })
        );
        mvpsOptions.push(this._generateSelectableMvpBmcElement(valueProposition));

        return mvpsOptions;
    }

    _generateSelectableVpElement(vpElement){
        return {
            label: vpElement.name,
            value:  vpElement.igtasksBoard
        }
    }

    _generateSelectableMvpBmcElement(valueProposition) {
        return {
            label: 'BMC',
            value: valueProposition.igtasksBoard
        }
    }

    _generateSelectableMvpFeatureElements(features, name) {
        return {
            label: this.rootStore.localeStore.intl.formatMessage({id: name}),
            options: features.map(feature => this._generateSelectableVpElement(feature))
        }
    }

    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // BACKEND CONNECTIONS
    @action
    fetchData(){
        if( this.rootStore.authorizationsStore.canFetchValuePropositions() ) {
            axios.get('/feedback_chains/value_propositions', {})
                .then(action((response) => {
                    this.valuePropositions = camelCase(response.data.value_propositions, true);
                    //this.mvpsSelectOptions = this.selectableMvpsBoards;
                }))
                .catch(action((error) => {
                    console.log(error);
                }));
        }
    }
    // end BACKEND CONNECTIONS
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

}